import Vue from 'vue'
import Vuex from 'vuex'
import user from './modules/user'
import permission from './modules/permission'
import permissionFuns from './modules/permissionFuns'
import approve from './modules/approve'
import login from './modules/login'
import getters from './getters'

Vue.use(Vuex)

const store = new Vuex.Store({
    state: {
        signImg: [],
        signImgMarket: [],
        singlePrice:''
    },
    mutations: { 
        pushImgUrl (state,newImgUrl) {
            state.signImg.push(newImgUrl)
        },
        pushImgUrlMarket (state,newImgUrl) {
            state.signImgMarket.push(newImgUrl)
        },
        changImgUrl (state,newImgUrl) {
            const arryLast = state.signImg.length - 1
            state.signImg[arryLast].imgUrl = newImgUrl
        },
        changImgUrlMarket (state,newImgUrl) {
            const arryLast = state.signImgMarket.length - 1
            state.signImgMarket[arryLast].imgUrl = newImgUrl
        },
        isSignedTime (state,isTime) {
            const arryLast = state.signImg.length-1
            state.signImg[arryLast].signTime = isTime
        },
        isSignedTimeMarket (state,isTime) {
            const arryLast = state.signImgMarket.length-1
            state.signImgMarket[arryLast].signTime = isTime
        }
        
    },
    modules: {
        user,
        permission,
        permissionFuns,
        login,
        approve
    },
    getters
})

export default store
